export default __webpack_public_path__ + "static/media/courseLanding-dataLeakage.bee35fc0.png";